import React from 'react';
import { func, shape } from 'prop-types';
import { Col, Image } from 'react-bootstrap';

import { Text } from 'Component/Ajaib';
import { PopUpCenter } from 'Component/PopUp';
import { noop } from '@ajaibid/utils';
import stylesGlobal from '@screens/style';
import { Button } from '@ajaibid/components';

const PopupInfoBP = ({ info, hideModal }) => {
  return (
    <PopUpCenter show={info.isOpen} onHide={hideModal} title="">
      <Col className="p-0 text-center" style={stylesGlobal.dGrid}>
        <div className="text-center">
          <Image
            style={{
              maxWidth: info.title ? '360px' : '100%',
              borderRadius: 8,
            }}
            src={info.img}
          />
        </div>
        <Text size="title" className="mt-16 text-body-bold">
          {info.title}
        </Text>
        <Text className="mt-16">{info.content}</Text>
        <Button variant="primary" className="mt-16" onClick={() => hideModal()}>
          Mengerti
        </Button>
      </Col>
    </PopUpCenter>
  );
};

PopupInfoBP.propTypes = {
  info: shape({}),
  hideModal: func,
};

PopupInfoBP.defaultProps = {
  info: {},
  hideModal: noop,
};

export default PopupInfoBP;
